const DefaultOptions = [
  {
    key: 'openProduction',
    text: 'Open',
    icon: 'fa-sign-in-alt',
    callbackName: 'enterProduction',
    trigger: 'context_menu',
  },
  {
    key: 'editDetails',
    text: 'Edit Details',
    icon: 'fa-edit',
    callbackName: 'openEditProductionsModal',
    trigger: 'context_menu',
  },
  {
    key: 'duplicateProduction',
    text: 'Duplicate',
    icon: 'fa-copy',
    callbackName: 'onDuplicateProduction',
    trigger: 'context_menu',
  },
  {
    key: 'deleteProduction',
    text: 'Delete',
    icon: 'fa-trash',
    callbackName: 'onDeleteProduction',
    trigger: 'context_menu',
  },
];

const DeletedOptions = [
  {
    key: 'restoreProduction',
    text: 'Restore',
    icon: 'fa-reply-all',
    callbackName: 'onRestoreProduction',
    trigger: 'context_menu',
  },
];

export {
  DefaultOptions,
  DeletedOptions,
};
